(() => {
  'use strict';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Set();
  function animate(element, frames, duration=850, delay=0) {
    if (!element || reduce.matches || !element.animate) return;
    const a=element.animate(frames,{duration,delay,easing:'cubic-bezier(.2,.7,.25,1)',fill:'backwards'});
    animations.add(a);
    const done=()=>animations.delete(a);
    a.addEventListener('finish',done,{once:true});a.addEventListener('cancel',done,{once:true});
  }
  const hero=document.querySelector('.home-hero');
  if(hero){
    ['.hero-copy .eyebrow','.hero-copy h1','.hero-copy>p','.hero-copy>.cta','.hero-copy>.hero-secondary','.hero-proof'].forEach((s,i)=>animate(hero.querySelector(s),[{opacity:1,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],550,i*30));
    animate(hero.querySelector('.hero-portrait'),[{opacity:1,transform:'translateY(10px)'},{opacity:1,transform:'translateY(0)'}],650,0);
    animate(hero.querySelector('.hero-handnote'),[{opacity:0,transform:'translateY(14px) rotate(-11deg)'},{opacity:1,transform:'translateY(0) rotate(-7deg)'}],1100,400);
  }
  if('IntersectionObserver'in window){
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      observer.unobserve(entry.target);
      const picture=entry.target.querySelector('.welcome-picture');
      const copy=entry.target.querySelector('.welcome-copy');
      animate(picture,[{opacity:.45,transform:'translateY(30px) rotate(-1deg)'},{opacity:1,transform:'translateY(0) rotate(0deg)'}],1000);
      animate(copy,[{opacity:.35,transform:'translateY(25px)'},{opacity:1,transform:'translateY(0)'}],900,130);
    }),{threshold:.18});
    document.querySelectorAll('.welcome-layout').forEach(el=>observer.observe(el));
  }
  let frame=0, visible=true;
  const portrait=hero?.querySelector('.hero-portrait img');
  function updatePortrait(){
    frame=0;
    if(!portrait||reduce.matches||!visible)return;
    const box=hero.getBoundingClientRect();
    const offset=Math.max(-12,Math.min(12,-box.top*.035));
    portrait.style.setProperty('--portrait-y',`${offset}px`);
  }
  function queue(){if(!frame&&portrait&&!reduce.matches&&visible)frame=requestAnimationFrame(updatePortrait);}
  if(portrait){
    if('IntersectionObserver'in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)queue();}).observe(hero);
    addEventListener('scroll',queue,{passive:true});addEventListener('resize',queue);queue();
  }
  reduce.addEventListener('change',()=>{
    if(reduce.matches){animations.forEach(a=>a.cancel());if(frame)cancelAnimationFrame(frame);frame=0;portrait?.style.removeProperty('--portrait-y');}
    else queue();
  });
})();
